import { IconButton, Modal, Typography } from "@mui/material";
import Grid from "@mui/material/Grid2";
import { FC, useState } from "react";
import { wrapperIcons, wrapperModal } from "../../routes.style";
import HighlightOffIcon from "@mui/icons-material/HighlightOff";
import Timer from "../../../../../components/timer";

interface IProps {
  loading: boolean;
  timer: any;
}

const IconsAction: FC<IProps> = ({ loading, timer }) => {
  const [open, setOpen] = useState(false);
  const handleOpen = () => {
    setOpen(true);
  };
  const handleClose = () => {
    setOpen(false);
  };

  return (
    <Grid
      sx={{
        ...wrapperIcons,
        background: (theme) => theme?.palette?.secondary?.main,
      }}
      container
      py={2}
      px={1}
    >
      <Typography variant="h4" mb={2}>
        Routes
      </Typography>
      <Grid container mt={-1.5}>
        <Timer timer={timer} loading={loading} />
        <IconButton style={{ paddingTop: "11px" }}>
          <img
            className={loading ? "loading" : ""}
            src="./assets/images/routes/refresh.svg"
            alt="flashift"
          />
        </IconButton>
        <IconButton onClick={handleOpen}>
          <img src="./assets/images/routes/question.svg" alt="flashift" />
        </IconButton>
        <Modal
          open={open}
          onClose={handleClose}
          aria-labelledby="child-modal-title"
          aria-describedby="child-modal-description"
        >
          <Grid sx={wrapperModal}>
            <IconButton onClick={handleClose}>
              <HighlightOffIcon />
            </IconButton>
            <Typography variant="h5" my={0.5}>
              AI Best Rate
            </Typography>
            <Typography mb={1}>
              Flashift's cutting-edge AI system is designed to continuously
              gather user feedback from multiple online sources and analyze
              various features. The system has identified that the exchange
              service delivers the most accurate and reliable rate, ensuring
              minimal discrepancies. This tag helps users choose the provider
              with the best rate and the highest rate trustworthiness, offering
              a better and more predictable exchange experience.
            </Typography>
            <Typography variant="h5" mb={0.5}>
              Recommended
            </Typography>
            <Typography mb={1}>
              Flashift's cutting-edge AI system is designed to continuously
              gather user feedback from multiple online sources and analyze
              various features such as exchange rates, KYC levels, and
              transaction speed. The system recommends the exchange service.
            </Typography>
            <Typography variant="h5" mb={0.5}>
              Best in KYC
            </Typography>
            <Typography mb={1}>
              Flashift's cutting-edge AI system is designed to continuously
              gather user feedback from multiple online sources and analyze
              various features such as exchange rates, KYC levels, and
              transaction speed. The system has identified that the exchange
              service has the lowest KYC level compared to other exchange
              services in the list.
            </Typography>
            <Typography variant="h5" mb={0.5}>
              KYC Hold Risk
            </Typography>
            <Typography mb={1}>
              Flashift’s cutting-edge AI system is designed to continuously
              gather user feedback from multiple online sources and analyze
              various features such as exchange rates, KYC levels, and
              transaction behaviour. The system has identified that this
              exchange provider may hold user funds until KYC verification is
              fully completed. Refunds are typically not issued when users fail
              or choose not to complete the verification process.
            </Typography>
          </Grid>
        </Modal>
      </Grid>
    </Grid>
  );
};
export default IconsAction;
